<template>
  <div
    class="page-wrap"
    :class="{
      'hide-right': collapsed,
      'show-right': !collapsed,
    }"
    v-loading="pageLoading"
  >
    <div class="left-box">

      <div class="expand-collapse">
        <el-icon class="icon-wrap" @click="clickCollapseEx">
          <Expand v-if="!collapsed" />
          <Fold v-else />
        </el-icon>
        <div v-if="dataInfo?.paper?.paperType == '501'"
            class="remain-time" ref="remainTime">
          练习时间：{{ showTimeDown}}
        </div>
        <div
            v-else-if="showTimeDown != '00：00：00'"
            class="remain-time" ref="remainTime">
          剩余时间：{{ showTimeDown}}
        </div>
      </div>



      <component
        v-if="currentIdx != null"
        :is="examView"
        v-model:currentQa="dataInfo.questionList[currentIdx]"
        :is-exercise="dataInfo?.paper?.paperType == '501'"
        @loading="(ev) => (pageLoading = ev)"
        @error="errorHandler"
        @save="saveQa()"
      />
    </div>

    <div class="right-box">
      <div class="inner">
        <div class="head">
          <span
              v-if="dataInfo?.paper?.paperType == '501'"
              class="count-down">练习时间：{{ showTimeDown }}</span>
          <span
              v-else-if="showTimeDown != '00：00：00'"
              class="count-down" v-show="remainSeconds >= 0">剩余时间：{{ showTimeDown }}</span>
          <div class="right-btns">
            <el-button type="primary" round size="small" @click="calVis = true">计算器 </el-button>
            <el-button type="danger" size="small" round @click="handlePaper(true)">我要交卷 </el-button>
          </div>
        </div>
        <div class="info-box" v-if="!(dataInfo?.paper?.paperType == '501')">
          <h3>{{ dataInfo?.exam?.examName }}</h3>
          <div class="stu-info">
            <div class="item">
              姓名：
              <div>{{ dataInfo?.user?.studentName }}</div>
            </div>

            <div class="item">
              准考证号：
              <div>{{ dataInfo?.user?.studentExamNo }}</div>
            </div>

            <div class="item">
              证件号：
              <div>{{ dataInfo?.user?.idNo }}</div>
            </div>
          </div>
        </div>

        <div class="ans-board">
          <div class="title-row">
            <h5>答题板</h5>
            <div>
              <el-button v-if="dataInfo?.paper?.paperType == '501'"
                         type="primary" size="small"
                         round @click="videoExplain(currentQa.videoId)">视频讲解 </el-button>
              <el-button v-if="currentQa.materials" type="primary" size="small" round @click="viewOnlineData">在线资料 </el-button>
            </div>
          </div>

          <div class="board-content-title">
            <div class="line"></div>
            <h5>{{ translateType(currentQa.queType) }}</h5>
          </div>

          <div class="rich-content">
            <view-rich-text
                v-if="currentQaBan"
                :text="currentQaBan"
                img-can-preview
                class="rich-text" />
          </div>
        </div>

        <div class="sheet-box">
          <div class="title-row">
            <h5>答题卡</h5>
            <div></div>
          </div>

          <div class="ans-sheet">
            <div class="type-item" v-for="(item, idx) in ansSheetList" :key="idx">
              <div class="name">{{ translateType(item.queType) }}</div>
              <div class="sheet-wrap">
                <div
                  class="sheet-item"
                  v-for="(qa, jdx) in item.qaList"
                  :class="{
                    current: qa.queNo == currentQa.queNo,
                    answered: Boolean(qa.fileUrl) || Boolean(qa.solution),
                    consider: qa.laterFlag == 1,
                  }"
                  @click="toggleAnsSheet(qa.originIdx)"
                  :key="idx + ',' + jdx"
                >
                  {{ qa.queNo }}
                </div>
              </div>
            </div>
          </div>

          <div class="opera-area">
            <el-button
              type="primary"
              size="small"
              round
              style="margin-left: 12px"
              :disabled="!dataInfo.questionList || currentIdx >= dataInfo.questionList.length - 1"
              @click="toggleAnsSheet(currentIdx + 1)"
            >
              下一题
            </el-button>

            <el-button v-if="currentQa.laterFlag == 1" round size="small" color="rgba(230, 162, 60, 1)" style="color: #ffffff" @click="consider(0)">
              取消考虑
            </el-button>

            <el-button
              v-else-if="currentQa.laterFlag == 0 || currentQa.laterFlag == null"
              round
              color="rgba(230, 162, 60, 0.7)"
              style="padding-left: 18px; padding-right: 18px; color: #ffffff; flex-shrink: 0; width: 34px; box-sizing: content-box; height: 12px"
              size="small"
              @click="consider(1)"
            >
              考&nbsp;&nbsp;虑
            </el-button>

            <el-button :disabled="currentIdx <= 0" @click="toggleAnsSheet(currentIdx - 1)" round size="small"> 上一题 </el-button>

            <el-button type="primary" round size="small" style="margin-left: 0" @click="redoQa"> 重新做题 </el-button>
          </div>
        </div>
      </div>
    </div>

    <rh-calculator v-model:visible="calVis" />

    <exam-result-dialog
      v-model:visible="examResVis"
      :data-info="examResInfo"
      :exam-stu-info-id="dataInfo?.examStudentInfo?.examStuInfoId"
      :exam-id="dataInfo?.exam?.examId"
    />

    <online-preview-dialog
        title="在线资料"
        :oss-path="currentQa.materials"
        v-model:visible="onlineDataVis"/>


    <tx-drag-play-dialog
        :video-id="videoId"
        v-model:visible="explainVis"
    />
  </div>
</template>

<script setup>
import {findExamInfo, saveQua, saveToggleRecord, submitPaper} from '@/api/examCenter/exam';
import RhCalculator from '@/components/RhComponent/RhCalculator';
import ExamResultDialog from '@/views/examCenter/common/examResultDialog';
import { $on, $emit } from 'vue-happy-bus';
import {ElMessage, ElMessageBox} from 'element-plus';
import ViewRichText from '@/components/RichText/ViewRichText.vue';
import TxDragPlayDialog from '@/components/TxPlayer/TxDragPlayDialog.vue';

import eDiagramCom from '@/views/examCenter/eDiagram/examCom.vue'; // E表题
import ReportTaxCom from '@/views/examCenter/reportTax'; // 报税题
import taxCom from '@/views/examCenter/tax/index.vue';
import taxDigitalAccount from '@/views/examCenter/taxDigitalAccount';
import digitalInvoice from '@/views/digitalInvoice/index';
import OnlinePreviewDialog from "@/components/OnlineWps/onlinePreviewDialogV2.vue";
//import OnlinePreviewDialog from "@/components/OnlineWps/onlinePreviewDialog.vue";
import cashier from '@/views/examCenter/cashier'; // 出纳题
import inspection from '@/views/examCenter/inspection'; // 工商年检
import onlineBankingCCB from '@/views/examCenter/onlineBankingCCB/index'; // 网银建行
let intervalId = null;
let remainSeconds = -1; // 考试剩余的秒数
const showTimeDown = ref('00：00：00');

const pageLoading = ref(false);
const calVis = ref(false);
const collapsed = ref(false);
const route = useRoute();
const examView = shallowRef(); // 题目展示组件

const dataInfo = ref({}); // 考试信息，完整数据
const ansSheetList = ref([]); // 分类答题卡列表
const currentIdx = ref(null); // 当前展示的题目下标信息

const currentQa = computed(() => {
  if (currentIdx.value == null) {
    return {};
  }
  return dataInfo.value.questionList[currentIdx.value];
});

const currentAllQa = computed(() => {
  return dataInfo.value.questionList || []
})

onMounted(() => {
  $on('exeSaveQa', (params = {}) => {
    saveQa(null, true, params);
  });
  fetchInfo();
});

function fetchInfo() {
  pageLoading.value = true;
  findExamInfo({
    examStudentInfoId: route.query.id,
  })
    .then((res) => {
      dataInfo.value = res.data || {};
      if (dataInfo.value.questionList.length) {
        ansSheetList.value = dataInfo.value.questionList.reduce((prev, item, idx) => {
          // 根据题目类型分组，然后显示答题卡
          const f = prev.find((s) => s.queType == item.queType);
          item.originIdx = idx; // 原来的下标记录，用于答题卡切题
          if (!f) {
            prev.push({
              queType: item.queType,
              qaList: [item],
            });
          } else {
            f.qaList.push(item);
          }
          return prev;
        }, []);
        toggleAnsSheet(0); // 默认展示第1题
      }
      if (dataInfo.value?.paper?.paperType == '501') {
        countUpTimer(dataInfo.value.examStudentInfo.examSeconds)
      } else {
        // countDownTimer(dataInfo.value.examStudentInfo.remainSeconds);
      }
      handleSaveToggleRecord() // 看了第1题
      pageLoading.value = false;
    })
    .catch((err) => {
      errorHandler(err);
    });
}

// 切换做题组件方法
function toggleComponent(targetIdx = null) {
  examView.value = null;
  grandchildValue.value = {
    // 还原默认通讯方法
    getData: () => {
      return {};
    },
    fillFinish: () => {
      return true;
    },
    getResetData: () => {
      return {};
    },
  };
  setTimeout(() => {
    if (targetIdx != null) {
      currentIdx.value = targetIdx;
    }
    switch (
      currentQa.value.queType // 切题后动态切换组件
    ) {
      case '1':
        examView.value = eDiagramCom;
        break;
      case '2':
        examView.value = ReportTaxCom;
        break;
      case '5':
        examView.value = taxCom;
        break;
      case '3':
        examView.value = digitalInvoice;
        break;
      case '4':
        examView.value = taxDigitalAccount;
        break;
      case '6':
        examView.value = cashier;
        break;
      case '7':
        examView.value = inspection;
        break;
      case '8':
        examView.value = onlineBankingCCB;
        break;
      default:
        examView.value = null;
        break;
    }
  }, 100);
}

// 切题
function toggleAnsSheet(idx) {
  const saveCurrentAndSwitch = () => {
    if (currentIdx.value != null) {
      saveQa();
      handleSaveToggleRecord()
    }
    toggleComponent(idx);
  };

  if (!grandchildValue.value.fillFinish()) {
    // 如果没做完，则提示
    let txt = currentQa.value.queType == '2' ? '' : '保存并'
    ElMessageBox.confirm(`当前题目还未做完，确认${txt}切题？`, '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        saveCurrentAndSwitch();
      })
      .catch(() => {});
  } else {
    saveCurrentAndSwitch();
  }
}

const grandchildValue = ref({
  getData: () => {
    // 保存时，父组件取孙子组件提供的数据，孙子组件覆盖此方法实现。
    return {};
  },
  fillFinish: () => {
    // 是否已经做完，返回false时，没做完切题会二次提示
    return true;
  },
  getResetData: () => {
    // 重新做题时，父组件取孙子组件提供的数据，孙子组件覆盖此方法实现。(即清空数据)
    return {}; // 返回空属性对象，会导致不调用保存接口
  },
});

// 取孙子组件的数据
provide('getGrandchildValue', grandchildValue);

provide('provideCurrentQa', currentQa) // 给孙子注入currentQa
provide('provideAllQa', currentAllQa) // 给孙子注入全部的题目数据
provide('topicBoardCollapsed', collapsed) // 给孙子注入是否折叠

// 单体保存接口
function saveQa(finishCall, byUser, params = {}) {
  const childrenData = grandchildValue.value.getData(byUser, params);
  const beforeSaveIdx = currentIdx.value;
  const serverData = {
    examStuInfoId: currentQa.value.examStuInfoId,
    queId: currentQa.value.queId,
    solution: null, // 答题内容
    fileUrl: currentQa.value.fileUrl,
    laterFlag: currentQa.value.laterFlag,
    examId: dataInfo.value.exam.examId,
    paperId: dataInfo.value.paper.paperId,
    ...childrenData,
  };
  saveQua(serverData)
    .then((res) => {
      if (res?.data?.startTiming == '1') {
        countDownTimer(res.data.limitDuration)
      }
      $emit('saveQaSuccess', {
        serverData,
        byUser: Boolean(byUser),
      }); // 发送垮层级事件

      Object.assign(dataInfo.value.questionList[beforeSaveIdx], childrenData); // 更新当前题目对象
      if (finishCall && typeof finishCall == 'function') {
        finishCall(1);
      }
    })
    .catch((err) => {
      if (finishCall && typeof finishCall == 'function') {
        finishCall(2);
      }
      errorHandler(err);
    });
}

// 重新做题，跟保存类似，通知后端存一份重置后的数据
function redoQa() {
  ElMessageBox.confirm('确定清空当前题目已答数据，重新作答？', '提示', {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: 'warning',
  })
    .then(() => {
      const childrenData = grandchildValue.value.getResetData();
      if (Object.keys(childrenData).length == 0) {
        // 数据为空，不掉接口
        return;
      }
      const beforeSaveIdx = currentIdx.value;
      const serverData = {
        examStuInfoId: currentQa.value.examStuInfoId,
        queId: currentQa.value.queId,
        solution: null, // 答题内容
        fileUrl: currentQa.value.fileUrl,
        laterFlag: currentQa.value.laterFlag,
        examId: dataInfo.value.exam.examId,
        paperId: dataInfo.value.paper.paperId,
        ...childrenData,
      };
      pageLoading.value = true;
      saveQua(serverData)
        .then((res) => {
          if (res?.data?.startTiming == '1') {
            countDownTimer(res.data.limitDuration)
          }
          pageLoading.value = false;
          Object.assign(dataInfo.value.questionList[beforeSaveIdx], childrenData); // 更新当前题目对象
          toggleComponent();
        })
        .catch((err) => {
          pageLoading.value = false;
          errorHandler(err);
        });
    })
    .catch(() => {});
}

function consider(laterFlag) {
  dataInfo.value.questionList[currentIdx.value].laterFlag = laterFlag;
}

const examResVis = ref(false);
const examResInfo = ref({});

// 交卷
function handlePaper(byUser) {
  const handleFunc = () => {
    pageLoading.value = true;
    saveQa((code) => {
      if (code == 2) {
        return;
      }
      submitPaper({
        examStuInfoId: dataInfo.value.examStudentInfo.examStuInfoId,
        examId: dataInfo.value.exam.examId,
        paperId: dataInfo.value.paper.paperId,
      })
        .then((res) => {
          pageLoading.value = false;
          examResInfo.value = {
            ...(res.data || {}),
            examType: dataInfo.value.exam.examType,
          };
          examResVis.value = true;
        })
        .catch(() => {
          pageLoading.value = false;
        });
    });
  };

  if (!byUser) {
    handleFunc();
    return;
  }

  ElMessageBox.confirm('确定要交卷吗？', '提示', {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: 'warning',
    closeOnClickModal: false,
    closeOnPressEscape: false,
  })
    .then(() => {
      handleFunc();
    })
    .catch(() => {});
}

onBeforeUnmount(() => {
  // 销毁实例
  if (intervalId != null) {
    clearInterval(intervalId);
    intervalId = null;
  }
});

function countDownTimer(second) {
  remainSeconds = second;
  showTimeDown.value = formatSeconds(remainSeconds);
  if (intervalId != null) {
    clearInterval(intervalId);
    intervalId = null;
  }
  if (second <= 0) {
    showTimeDown.value = formatSeconds(0);
    return
  }
  intervalId = setInterval(() => {
    remainSeconds--;
    showTimeDown.value = formatSeconds(remainSeconds);

    if (remainSeconds <= 0) {
      clearInterval(intervalId);
      intervalId = null;
      showTimeDown.value = formatSeconds(0);
      // handlePaper(false); // 前端自动交卷
    }
  }, 1000);
}

let currentSeconds = 0
//正计时：针对练习
function countUpTimer(second) {
  currentSeconds = second;
  showTimeDown.value = formatSeconds(currentSeconds);
  if (intervalId != null) {
    clearInterval(intervalId);
    intervalId = null;
  }
  intervalId = setInterval(() => {
    currentSeconds++;
    showTimeDown.value = formatSeconds(currentSeconds);
  }, 1000);
}

const router = useRouter();

// 做题错误处理器，拦截已交卷等行为
function errorHandler(err) {
  console.log('信息', err);
  if (err?.toString().indexOf('已交卷') > -1) {
    pageLoading.value = false;
    ElMessageBox.alert('考试已交卷', '提示', {
      showClose: false,
      confirmButtonText: '去结果页',
      autofocus: false,
      callback: () => {
        router.replace({
          name: 'ExamAnalysis',
          query: {
            id: route.query.id,
          },
        });
      },
    });
  }
}

function formatSeconds(seconds) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  // 格式化为两位数
  const formattedHours = String(hours).padStart(2, '0');
  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(remainingSeconds).padStart(2, '0');

  return `${formattedHours}：${formattedMinutes}：${formattedSeconds}`;
}

const onlineDataVis = ref(false);

function viewOnlineData() {
  onlineDataVis.value = true;
}

function translateType(type) {
  switch (type) {
    case '1':
      return 'E表';
    case '2':
      return '报税题';
    case '3':
      return '数电发票';
    case '4':
      return '税务数字账户';
    case '5':
      return '个税';
  }
}

const remainTime = ref()

function clickCollapseEx() {
  collapsed.value = !collapsed.value
  if (collapsed.value) { // 折叠了
    setTimeout(() => {
        remainTime.value && remainTime.value.classList.add('show');
    }, 800)
  } else {
      remainTime.value && remainTime.value.classList.remove('show');
  }
}

const explainVis = ref(false)
const videoId = ref('')

function videoExplain(vid) {
  if (!vid) {
    ElMessage.warning('该题未配置讲解，请与校区老师联系')
    return
  }
  videoId.value = vid
  explainVis.value = true
}


const subQaBoard = ref(null)

$on('setQuestionBoard', boardTxt => {
  subQaBoard.value = boardTxt || null
});

const currentQaBan = computed(() => {
  if (subQaBoard.value) {
    return subQaBoard.value
  }
  return currentQa.value.queDesc
})

function handleSaveToggleRecord() {
  saveToggleRecord(route.query.id)
      .then(res => {
        if (res?.data?.startTiming == '1') {
          countDownTimer(res.data.limitDuration)
        }
      })
}
</script>

<style scoped lang="scss">
.page-wrap {
  height: 100%;
  position: relative;
  $rightBoxWidth: 400px;
  $transition-time: 0.8s;
  font-size: 16px;

  .left-box {
    position: relative;
    margin-right: $rightBoxWidth;
    height: 100%;

    .expand-collapse {
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
      font-size: 20px;
      display: flex;
      border-radius: 4px 0 0 4px;
      background: #40cb99;
      color: #ffffff;
      z-index: 9999;
      .icon-wrap {
        width: 50px;
        height: 50px;
      }
      .remain-time {
        font-size: 16px;
        font-weight: 600;
        line-height: 50px;
        padding-right: 10px;
        display: none;
        &.show {
          display: block;
        }
      }
    }
  }

  .right-box {
    position: absolute;
    right: 0;
    top: 0;
    width: $rightBoxWidth;
    height: 100%;
    z-index: 20;
    box-sizing: border-box;
    box-shadow: -2px 0 4px 0 rgba(0, 0, 0, 0.1);
    overflow-x: hidden;
    background-color: #ffffff;

    .inner {
      height: 100%;
      padding: 20px;
      width: $rightBoxWidth;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;

      .head {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .count-down {
          color: #ff3051;
          font-size: 16px;
          line-height: 22px;
          font-weight: 600;
        }

        .right-btns {
        }
      }

      .info-box {
        margin-top: 20px;
        border-radius: 4px;
        background: #f5f6f7;
        padding: 10px 0 10px 20px;

        > h3 {
          text-align: center;
          color: #333333;
          font-size: 14px;
          font-weight: 600;
          line-height: 20px;
        }

        .stu-info {
          display: flex;
          color: #333333;
          font-size: 12px;
          margin-top: 10px;
          line-height: 17px;

          .item {
            flex-grow: 1;
          }
        }
      }

      .ans-board {
        margin-top: 20px;
        padding-top: 20px;
        border-top: 1px solid #d9d9d9;
        height: 0;
        flex-grow: 1;

        .title-row {
          display: flex;
          justify-content: space-between;
          align-items: center;

          > h5 {
            color: #333333;
            font-weight: 500;
            font-size: 20px;
            line-height: 28px;
          }
        }

        .board-content-title {
          margin-top: 20px;
          color: #3498ff;
          font-size: 18px;
          line-height: 26px;
          font-weight: 500;
          display: flex;
          align-items: center;

          .line {
            height: 26px;
            width: 4px;
            background-color: #3498ff;
            margin-right: 10px;
          }
        }

        .rich-content {
          height: calc(100% - 88px); // 计算得出
          margin-top: 10px;
          overflow-y: auto;
        }
      }

      .sheet-box {
        $totalHeight: 210px;
        $margin-inner-top: 20px;
        $titleHeight: 28px;
        $operaHeight: 25px;
        margin-top: 20px;
        padding-top: 20px;
        border-top: 1px solid #d9d9d9;
        height: $totalHeight;

        .title-row {
          display: flex;
          justify-content: space-between;
          height: $titleHeight;

          > h5 {
            color: #333333;
            font-weight: 500;
            font-size: 20px;
            line-height: 28px;
          }
        }

        .ans-sheet {
          margin-top: $margin-inner-top;
          font-size: 12px;
          // 计算得出
          height: calc(#{$totalHeight} - #{$margin-inner-top} - #{$margin-inner-top} - #{$titleHeight} - #{$operaHeight});
          overflow-y: auto;

          .type-item {
            display: flex;

            & + .type-item {
              margin-top: 10px;
            }

            .name {
              flex-shrink: 0;
              line-height: 30px;
            }

            .sheet-wrap {
              margin-left: 10px;
              display: flex;
              flex-wrap: wrap;
              margin-top: -6px;

              .sheet-item {
                cursor: pointer;
                width: 30px;
                height: 30px;
                border: 1px solid #eee;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 4px;
                margin-left: 6px;
                margin-top: 6px;
                user-select: none;

                &.consider.consider {
                  background-color: #ffe9ce;
                }

                &.answered {
                  background-color: #cbe4fd;
                  border-color: #cbe4fd;
                }

                &.current {
                  border: 2px solid var(--el-color-primary);
                }
              }
            }
          }
        }

        .opera-area {
          margin-top: $margin-inner-top;
          height: $operaHeight;
          display: flex;
          flex-direction: row-reverse;
        }
      }
    }
  }

  &.show-right {
    .left-box {
      transition: $transition-time margin-right;
    }

    .right-box {
      transition: $transition-time width;
    }
  }

  &.hide-right {
    .left-box {
      transition: $transition-time margin-right;
      margin-right: 0;
    }

    .right-box {
      transition: $transition-time width;
      width: 0;
    }
  }
}
</style>
